import React from 'react';
import Relay from 'react-relay';

export default class TodoList extends React.Component {
  static propTypes = {
    viewer: React.PropTypes.object.isRequired
  };

  render() {
    return (
      <div className="main">
        This.is.sparta
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TodoList.js
 **/